var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10869",
    "data-name": "Group 10869",
    transform: "translate(-7094.5 -164.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8543",
    "data-name": "Group 8543",
    transform: "translate(7095 165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    className: "cls-1",
    d: "M13.054,36.615A12.522,12.522,0,0,1,.5,24.088c0-.294.027-.556.027-.85a2.356,2.356,0,0,1,2.011-1.077A2.222,2.222,0,0,1,4.577,23.58V24.2a8.477,8.477,0,1,0,14.807-5.7,1.965,1.965,0,0,1,.912-2.433,2.168,2.168,0,0,1,2.039-.214,12.469,12.469,0,0,1-9.281,20.771",
    transform: "translate(-0.5 -11.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    className: "cls-1",
    d: "M22.408,4.729A12.475,12.475,0,0,0,.6,12.143a2.476,2.476,0,0,1,2.012-1.1A2.222,2.222,0,0,1,4.65,12.465,8.508,8.508,0,0,1,19.43,7.352a2.084,2.084,0,0,1,.939-2.436A2.273,2.273,0,0,1,22.408,4.729Z",
    transform: "translate(-0.573 -0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/defaultIcon.34ed0c2c4a7e071a97cd34a2fd28815d.svg";
export { ForwardRef as ReactComponent };